module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BRVy9H/tc-custom/9781440501029.jpg?1730520067820",
      "alt": "This image is the cover for the book Complete Guide to Reverse Mortgages"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Complete Guide to Reverse Mortgages\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Get the most from your home!")]), _c('br'), _c('br'), _vm._v("Until recently, there were only two main ways you could get cash from your home: sell it or borrow against it and make monthly loan repayments. Reverse mortgages offer a third way of getting money from your home. If you are a homeowner, age 62 and older, you are eligible to apply for a reverse mortgage loan that converts your home equity into a tax-free income."), _c('br'), _c('br'), _vm._v(" With "), _c('i', [_vm._v("The Complete Guide to Reverse Mortgages")]), _vm._v(", you’ll learn all you need to know to earn the supplemental income you need, without worrying about:"), _c('br'), _c('br'), _vm._v(" • Having to sell your home"), _c('br'), _vm._v(" • Giving up your title"), _c('br'), _vm._v(" • Taking on a new monthly mortgage payment"), _c('br'), _c('br'), _vm._v(" This invaluable guide explains everything you need to know about reverse mortgages and how to use them to your advantage. With practicing attorneys Tammy Kraemer and Tyler Kraemer leading the way, you will learn the step-by-step process to getting a reverse mortgage and making the best of your retirement!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tammy Kraemer, Tyler Kraemer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0